export const MissingIntegrationGeneracTroubleshooting = () =>
    <div>
        <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
            <p className="my-4">
                The "Missing Credentials" error for Generac systems can show when a company has
                correctly associated their Generac account at the company level, but they have not yet
                associated any of their sites at the site level OR when a company has failed to associate at
                both the company and site level. We cannot verify a company-level connection until at least one
                site is associated.
            </p>

            <h4 className="font-semibold">
                Step One: Verify that a valid Manufacturer System ID is populated on the Warranty Details
            </h4>
            <ul className="mt-4 list-decimal pl-5">
                <li>Navigate to the "Warranty Holder Details - Warranty Tab".</li>
                <li>
                    Click on the "Edit Warranty" option to access and modify the warranty enrollment details.
                </li>
                <li>
                    Ensure that the Manufacturer System Identifier is populated and correct. This should be
                    populated with the site ID for the related installation found in your PWRfleet portal.
                    <div>
                        a. In PWRfleet, Navigate to the "All Sites" list to find the related system.
                    </div>
                    <div>b. Click on the system to open its details page.</div>
                    <div>
                        c. The Site ID can be found in the URL of the site. It is the unique identifier after
                        /sites/ in the URL.
                    </div>
                </li>
                <li>Update the ID on the Solar Insure Daybreak Platform and save the changes.</li>
            </ul>
            <h4 className="font-semibold mt-4">
                Step Two: Verify that you have set up Monitoring Data Sharing Access at the Company Level on
                PWRfleet
            </h4>
            <ul className="mt-4 list-decimal pl-5">
                <li>
                    Log into the Generac portal at <a
                        href="https://mypwrview.generac.com/login"
                        className="text-primary-700 underline"
                        target="_blank"
                        rel="noreferrer"
                    >https://mypwrview.generac.com/</a> and select the three-dot menu.
                </li>
                <li>
                    Navigate to "Account Settings" and in the dropdown, go to the "Company
                    Associations" section. Here you will see a list of your installation partners.
                </li>
                <li>Select "Associations Requests".</li>
                <li>
                    If you need to request an association with a financing or O&M partner, click on the
                    "Request Association" button in the "Your financing and O&M partners"
                    section to open up further options.</li>
                <li>
                    A pop-up will appear prompting you to associate companies with your PWRfleet. Enter
                    monitoring@solarinsure.com address into the field provided.
                </li>
            </ul>
            <h4 className="font-semibold mt-4">
                Step Three: Verify that this Individual Site is Shared with Solar Insure
            </h4>
            <ul className="mt-4 list-decimal pl-5">
                <li>Log into the PWRfleet portal.</li>
                <li>
                    Navigate to the "All Sites" list to find the related system. Click on the system
                    to open its details page.
                </li>
                <li>Click on the "Access" tab in the left sidebar.</li>
                <li>Select "Share Site".</li>
                <li>Select Solar Insure and click "Share".</li>
                <li>
                    Return to the Daybreak platform. Click on the refresh monitoring button to initiate a new
                    attempt to pull monitoring data.
                </li>
            </ul>
        </div>
    </div>
